export default __webpack_public_path__ + "static/media/a037-m.38344de4.jpg";